import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'
import { push } from 'react-router-redux'

import * as UserSelectors from 'modules/user/selectors'
import * as UserActions from 'modules/user/actions'
import FindMyTeamEmailSent from './component'

const redirectToVerify = (props) => {
  props.actions.resetFindMyTeamState()
  props.actions.push('/start/findTeam/verify')
}

const mapStateToProps = state => ({
  email: UserSelectors.getEmail(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    resetFindMyTeamState: UserActions.sendFindMyTeamVerificationEmailReset,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onEntryValidate: props => () => {
      if (!props.email) {
        redirectToVerify(props)
      }
    },
    onTryAgain: props => () => {
      redirectToVerify(props)
    }
    },
  )
)(FindMyTeamEmailSent)



// WEBPACK FOOTER //
// ./src/layouts/FindMyTeam/FindMyTeamEmailSent/index.js